import { render, staticRenderFns } from "./recepcionDeposito.vue?vue&type=template&id=06a5e697"
import script from "./recepcionDeposito.vue?vue&type=script&lang=js"
export * from "./recepcionDeposito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports